import { createFileRoute } from '@tanstack/react-router';
import { RecoveryRequestPage } from '@pages/recovery';

export const Route = createFileRoute('/$locale/forgot-password')({
  component: ForgotPasswordRoute,
});

function ForgotPasswordRoute() {
  const { locale } = Route.useParams();
  return <RecoveryRequestPage locale={locale as 'en' | 'ru'} purpose="password_reset" />;
}
